
import { BLOG, create_link } from "../constants";
import { Link } from "react-router-dom";

export default function Blog() {
  return (
    <div className="container pt-12 pb-20">
      <h2 className="max-w-xl mx-auto headings text-center mb-4">
        Read Our Latest Stories & Articles
      </h2>

      <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-4 gap-6 xl:gap-5">
        {BLOG.map((blog, i) => (
          <div key={i} className="border rounded overflow-hidden group">
            <div className="aspect-[3/2] overflow-hidden">
              <img
                src={blog.image[0].image}
                alt={blog.title}
                fill={false}
                className="object-cover w-full aspect-[3/2] transition duration-500 ease-in-out group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <h4 className="font-medium mb-3 line-clamp-1">{blog.title}</h4>
              <p className="line-clamp-4 gray-color text-sm">
                {blog.description}
              </p>

              <div className="mt-6 mb-3">
                <Link
                  to={`/blog/${create_link(blog.title)}`}
                  className="main-btn px-8 py-3 "
                >
                  Read more
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
